import { createAction, createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/verificacion';

function validarCorrecto(state, action) {
  const { responseValidar } = action.payload;
  state.response = responseValidar;
  state.responseError = false;
}


function validarError(state, action) {
  const { responseValidar } = action.payload;
  state.response = responseValidar;
  state.responseError = true;
}


const verificacion = createAction('verificacion');


const verificacionReducer = createSlice({
  name: 'verificar',
  initialState: initState,
  reducers: {
    validarCorrecto,
    validarError,
  },
});

export const verificacionActions = {
  ...verificacionReducer.actions,
  verificacion,
};

export default verificacionReducer.reducer;
